import React from "react";
import { useEffect } from "react";
import { Router, routes } from "./router/Router";
import { Frame } from "@shopify/polaris";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@shopify/polaris/build/esm/styles.css";
import "./assets/css/style.css";

function App() {
  useEffect(() => {
    if (document.getElementById("tawk-script")) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];

    s1.id = "tawk-script";
    s1.async = true;
    s1.src = "https://embed.tawk.to/6a4b9add4d65411d4822dd93/1jsrl9sgn";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    s0.parentNode.insertBefore(s1, s0);

    return () => {
      const script = document.getElementById("tawk-script");
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Router />}>
            {routes.map((route, i) => (
              <Route
                exact={true}
                path={route.path}
                key={i}
                element={<Frame>{route.component}</Frame>}
              />
            ))}
            <Route element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
